// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__8pfLX","right":"styles_right__3RM1u"};